import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'

function NavBarButtonMobile({ path, children }) {
  const match = useRouteMatch(path)?.isExact

  return (
    <Link
      className={`
        block
        mb-1
        pl-3
        pr-4
        py-2
        text-base
        font-medium
        no-underline
        border-l-4
        border-transparent
        text-gray-500
        hover:text-gray-500
        hover:no-underline
        hover:border-gray-300
        hover:bg-gray-50
        ${
          match &&
          `
            border-blue-600
            bg-blue-100
            text-blue-600
            hover:text-blue-600
            hover:border-blue-600
            hover:bg-blue-100
          `
        }
        transition
        duration-150
        ease-in-out
      `}
      to={path}
    >
      {children}
    </Link>
  )
}

export default NavBarButtonMobile
